var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPictureInPicture = function SvgIconPictureInPicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M20.914 4.182c.625 0 1.132.523 1.132 1.169V20.55c0 .646-.507 1.17-1.133 1.17H3.092c-.626 0-1.133-.524-1.133-1.17V5.35c0-.203.05-.395.14-.562a1 1 0 0 1 .91-.606zM12.01 5.35h8.904V20.55H3.092v-7.078h7.918c.552 0 1-.462 1-1.032zM3.092 12.44V5.35h7.918v7.09z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPictureInPicture;